import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../styles/AddressForm.css";
import { CUSTOMER_ADD_FAMILY_MEMBER } from "../../component/common/Routes/CustomerRoutes";
import Loading from "../../component/ui/Loading";
import * as actions from "../../redux/FamilyMembers/actions";
import { formatDate } from "../../Style";
import CustomButton from "../../component/ui/FormFields/Button";

export default function FamilyMembers() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const customerId = user?.customer_id;

  const { familyMembers, loading, error } = useSelector(
    (state) => state.familyMember
  );
  console.log(
    "Family Members",
    useSelector((state) => state.familyMember)
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  useEffect(() => {
    dispatch(actions.fetchFamilyMembersRequest(customerId));
  }, [dispatch, customerId]);

  useEffect(() => {
    if (error) {
      toast.error(error, {
        position: "top-center",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: false
      });
    }
  }, [error]);

  const handleDeleteClick = (member) => {
    setSelectedMember(member);
    setOpenDialog(true);
  };

  const handleConfirmDelete = () => {
    if (selectedMember) {
      dispatch(actions.deleteFamilyMemberRequest(selectedMember.id));
      dispatch({
        type: "DELETE_FAMILY_MEMBER_SUCCESS",
        payload: selectedMember.id
      });
      toast.success("Family member deleted successfully", {
        position: "top-center",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: false
      });
    }
    setOpenDialog(false);
  };

  if (loading) {
    return <Loading text="Loading family Members..." />;
  }

  return (
    <>
      <ToastContainer />
      <Box className="container">
        <Box mb={3} className="header">
          <Button
            variant="contained"
            className="add-button"
            onClick={() => navigate(CUSTOMER_ADD_FAMILY_MEMBER)}
          >
            Add Family Member
          </Button>
        </Box>

        {familyMembers.length === 0 ? (
          <Box textAlign="center" mt={4}>
            <Typography variant="h6">No family members found.</Typography>
          </Box>
        ) : (
          <Grid container spacing={3}>
            {familyMembers.map((member) => (
              <Grid item xs={12} sm={6} key={member.id}>
                <Card className="address-card">
                  <CardContent>
                    <Typography variant="h6" className="address-name">
                      {member.first_name} {member.last_name}
                    </Typography>
                    <Typography variant="body1" className="address-details">
                      Date of Birth: {formatDate(member.dob)}
                    </Typography>
                    <Typography variant="body1" className="mobile-info">
                      Gender:{" "}
                      {member.gender_type === "M"
                        ? "Male"
                        : member.gender_type === "F"
                        ? "Female"
                        : "Others"}
                    </Typography>
                    <Typography variant="body1" className="address-details">
                      Age: {member.age}
                    </Typography>
                    <Typography variant="body1" className="address-details">
                      Nationality: {member.nationality}
                    </Typography>
                    {member.passport_number && (
                      <Typography variant="body1" className="address-details">
                        Passport Number: {member.passport_number}
                      </Typography>
                    )}
                    {member.aadhar_number && (
                      <Typography variant="body1" className="address-details">
                        Aadhar Number: {member.aadhar_number}
                      </Typography>
                    )}
                    <Typography variant="body1" className="mobile-info">
                      Mobile: {member.phone}
                    </Typography>

                    <Box className="card-footer">
                      <Box className="button-container">
                        <Button
                          variant="contained"
                          className="orange-button"
                          onClick={() =>
                            navigate(
                              `/customer/familyMembers/edit/${member.id}`
                            )
                          }
                        >
                          Edit
                        </Button>

                        <Button
                          variant="contained"
                          className="grey-button"
                          onClick={() => handleDeleteClick(member)}
                        >
                          Delete
                        </Button>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            Are you sure you want to delete{" "}
            <strong>
              {selectedMember?.first_name} {selectedMember?.last_name}
            </strong>
            ?
          </DialogContent>
          <DialogActions>
            <Button
              size="small"
              onClick={() => setOpenDialog(false)}
              className="handle-back"
            >
              Cancel
            </Button>
            <CustomButton
              variant="contained"
              className="handle-delete"
              type="button"
              size="small"
              loading={loading}
              text={"DELETE"}
              onClick={handleConfirmDelete}
            />
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
}
